import { createAsyncThunk } from "@reduxjs/toolkit";
import { referentialsApi } from "services/swagger-api/referentialsAPI";

export const getAllReferentials = createAsyncThunk(
  'subscriptionProcess/getAllReferentials',
  async () => {
    return await referentialsApi.getReferentials()
  }
);
